import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple, FuseAnimate} from '@fuse';

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';
import { Paper, Grid, Chip, Typography, ListItem} from '@material-ui/core';
import Pagination from "material-ui-flat-pagination";

import HomeIcon from '@material-ui/icons/Home';

const styles = theme => ({
    layoutRoot: {},
    pagingPeringkat: {
        textAlign: 'right'
    },
    tabSelected: {
        borderBottom: '5px solid #4EBAE7',
        background: '#ECEFF1',
        color: 'white'
    },
});

class Notifikasi extends Component {
    state = {
        error:0,
        routeParams:{
            foo: 'bar',
            limit: 20
        },
        valueTab: 0
    }

    goTolink = (url) => {
        this.props.setNotifikasiBaca(this.state.routeParams);
        this.props.history.push(url);
    };

    componentDidMount = () => {
        this.props.setJudul('Notifikasi');
        this.props.getNotifikasi(this.state.routeParams).then((reslt)=>{
            this.setState({
                total: this.props.notifikasi.total
            });
        });
    }

    loadData = (e, offset) => {
        this.setState({
            ...this.state,
            offset: offset,
            routeParams: {
                ...this.state.routeParams,
                start: offset
            }
        },()=>{
            this.props.getNotifikasi(this.state.routeParams).then((reslt)=>{
                this.setState({
                    total: this.props.notifikasi.total
                });
            });
        })
    }

    render()
    {
        const {classes} = this.props;
        
        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot
                }}
                content={
                    <FuseAnimate
                        animation="transition.slideRightBigIn"
                        duration={400}
                        delay={400}
                    >
                        <div style={{width: '100%', padding: 10}} className="konten-utama">
                            {/* <GhostList/>
                            <GhostList/>
                            <GhostList/>
                            <GhostList/> */}
                            <div style={{minHeight: 10, width: '100%', background: '#4EBBE8', overflow: 'auto', maxHeight: '42px', display: 'inline-flex'}}>
                                <Chip
                                    icon={<HomeIcon/>}
                                    label=""
                                    className={this.props.classes.chip}
                                    color="primary"
                                    style={{justifyContent: 'start', marginLeft: 0, padding: 5, borderRadius: 0, borderRight: '1px solid #ccc', paddingLeft: '0px', paddingRight: '0px'}}
                                    onClick={()=>{this.goTolink('/Beranda')}}
                                />
                                <Chip
                                    label={"> Notifikasi"}
                                    className={this.props.classes.chip}
                                    color="secondary"
                                    // onClick={()=>{this.goTolink('/ManajemenPengguna')}}
                                    style={{justifyContent: 'start', marginRight: 0, padding: 5, borderRadius: 0, paddingLeft: 0, paddingRight: 0, fontSize: 12}}
                                />
                            </div>
                            <Paper className="rounded elevation5">
                                <Grid container>
                                    <Grid item xs={12} sm={12} style={{textAlign: 'left'}}>
                                            <Pagination
                                            limit={20}
                                            offset={this.state.offset}
                                            total={this.state.total}
                                            innerButtonCount={1}
                                            style={{width: '100%'}}
                                            onClick={this.loadData}
                                            />
                                    </Grid>
                                </Grid>
                            </Paper>
                            <Paper className="m-8" style={{marginBottom:'10px'}}>
                            {this.props.notifikasi.rows.map((option)=>{
                                let bg = 'white';
                                if(option.status === "1"){
                                    bg = '#fafafa';
                                }

                                return (
                                    <ListItem onClick={()=>this.goTolink(option.tautan)} style={{borderRadius:'0px',borderBottom: '1px solid #ccc', background:bg}} elevation={0} button className="p-8 border-b-1 border-gray-200">
                                        <Typography variant="caption">
                                            <span style={{fontSize:'14px', fontWeight:'bold'}}>{option.jenis_notifikasi}</span>
                                            <br/>
                                            {option.keterangan}
                                            <br/>
                                            <b>{option.create_date}</b>
                                        </Typography>
                                    </ListItem>
                                )
                            })}
                            </Paper>
                        </div>
                    </FuseAnimate>
                }
            />
        )
    }

}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getSekolah: Actions.getSekolah,
        setKunciKonfirmasiInstrumen: Actions.setKunciKonfirmasiInstrumen,
        getKonfirmasiSelesai: Actions.getKonfirmasiSelesai,
        getKemajuanTotal: Actions.getKemajuanTotal,
        getPeringkatPengisian: Actions.getPeringkatPengisian,
        setLoading: Actions.setLoading,
        setJudul: Actions.setJudul,
        getProsesRapor: Actions.getProsesRapor,
        getRaporMutuRadar: Actions.getRaporMutuRadar,
        setDataTahun: Actions.setDataTahun,
        setDataWilayah: Actions.setDataWilayah,
        getNotifikasi: Actions.getNotifikasi,
        setNotifikasiBaca: Actions.setNotifikasiBaca
    }, dispatch);
}

function mapStateToProps({ Sekolah, Instrumen, RaporMutu, App }) {

    return {
        sekolah: Sekolah.sekolah,
        konfirmasi_instrumen_id: Instrumen.konfirmasi_instrumen_id,
        konfirmasi_instrumen: Instrumen.konfirmasi_instrumen,
        kemajuan_total: Instrumen.kemajuan_total,
        peringkat_pengisian: Instrumen.peringkat_pengisian,
        proses_rapor_mutu: RaporMutu.proses_rapor_mutu,
        rapor_mutu_radar: RaporMutu.rapor_mutu_radar,
        data_tahun: RaporMutu.data_tahun,
        data_wilayah: RaporMutu.data_wilayah,
        notifikasi: App.notifikasi,
        hasil_notifikasi_baca: App.hasil_notifikasi_baca
    }
}

// export default withStyles(styles, {withTheme: true})(Beranda);
export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(Notifikasi)));



// WEBPACK FOOTER //
// ./src/main/content/Notifikasi/Notifikasi.js